import { Component, OnInit, Input } from '@angular/core';
import { PaymentAccountConfigBaseComponent } from '../payment-account-config-base/payment-account-config-base.component';
import { UnibankPaymentProcessorAccountConfiguration } from 'src/app/models/payment-providers/unibank/unibank-payment-processor-account-configuration';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { PaymentProcessor } from 'src/app/models/payment-processor';
@Component({
  selector: 'wm-payment-account-config-unibank',
  templateUrl: './payment-account-config-unibank.component.html',
  styleUrls: ['./payment-account-config-unibank.component.css'],
  standalone: false
})
export class PaymentAccountConfigUnibankComponent
  extends PaymentAccountConfigBaseComponent
  implements OnInit {

  @Input() config: UnibankPaymentProcessorAccountConfiguration;
  @Input() processor: PaymentProcessor;

  constructor(fb: UntypedFormBuilder) {
    super(fb);

    // ❗ Unibank does NOT use username/password
    this.showUsername = false;
    this.showPassword = false;
  }

  ngOnInit() {
    // ✅ Required fields for Unibank
    this.addValidation('accessKey', Validators.required, this.config.accessKey);
    this.addValidation('customerId', Validators.required, this.config.customerId);
    this.addValidation('transactionId', Validators.required, this.config.transactionId);

      this.addValidation('invoiceField', Validators.required, this.config.invoiceField);
    this.addValidation('customerField', Validators.required, this.config.customerField);
    this.addValidation('locationField', Validators.required, this.config.locationField);
    this.addValidation('descriptionField', Validators.required, this.config.descriptionField);

    // Optional
    // this.addValidation('postBackUrl', [], this.config.postBackUrl);


    console.log('CONFIG BEFORE SAVE:', this.config);
    this.form.valueChanges.subscribe(values => {
   
    // this.config.postBackUrl = values.postBackUrl;
     this.config.accessKey = values.accessKey;
    this.config.customerId = values.customerId;
    this.config.transactionId = values.transactionId;

    this.config.invoiceField = values.invoiceField;
    this.config.customerField = values.customerField;
    this.config.locationField = values.locationField;
    this.config.descriptionField = values.descriptionField;

 // 🔥 FIX: attach URL from processor config
  const processor: any = (this as any).processor;

  if (!this.config.providerSettings) {
    this.config.providerSettings = {};
  }

  if (!this.config.providerSettings.url && processor) {
    this.config.providerSettings.url = processor.inTestMode
      ? processor.testConfiguration?.url
      : processor.configuration?.url;
  }
  });
  }
}